import React from "react";
import { NumericFormat } from 'react-number-format';

const NumberFormatCustom = (props) => {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            isNumericString
            prefix="$"
        />
    );
}

export default NumberFormatCustom;